module.exports = __webpack_public_path__ + "static/media/360-icon.80422f71.svg";